import axios from 'axios';
import merge from 'deepmerge';
import UserInitializer from 'lib/UserInitializer';

const UPDATE = 'pulp/userDetail/UPDATE';

export const initialState = {
  username: null,
  firstName: null,
  lastName: null,
  workEmail: null,
  tradeName: null,
  agencyLogoUri: null,
  photo: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE:
      return merge(state, action.payload);
    default:
      return state;
  }
}

export function updateUserDetails(payload) {
  return {type: UPDATE, payload};
}

export function loadUserDetails() {
  return (dispatch, getState) => axios.get('/api/user_details').then(({data}) => {
    dispatch(updateUserDetails(data));
    UserInitializer.initializeAnalytics(data, dispatch, getState);
    // Defer loading the user's preferences until after FF to allow for validating redirects
    // Maybe consider a dedicated startup controller, there may be some race condition bugs here
    UserInitializer.initializeLaunchDarkly(data, dispatch);
    UserInitializer.initializeApm(data);
  });
}